import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectULTemplateCount = createSelector(
  [(store: RootState) => store.templateList.templatesUserLocation],
  (data) => data.length
);
